import React, { useState, useEffect, useContext } from 'react';
import CaminoCategorias from './CaminoCategorias';
import OrdenarProductos from './OrdenarProductos';

function CabeceraHistorialOrden({ selectedOrden, setSelectedOrden, categoriaSeleccionada }) {
  const [caminoCategoria, setCaminoCategoria] = useState([]);

  // Construir el array de categorías basado en la categoría seleccionada
  useEffect(() => {
    setCaminoCategoria(categoriaSeleccionada);
  }, [categoriaSeleccionada]);

  return (
    <div className='w-full h-20 p-3 flex'>
      <div className='flex justify-start items-center h-full w-full'>
        {/* Componente CaminoCategorias para mostrar el camino */}
        <CaminoCategorias caminoCategoria={caminoCategoria} />
      </div>
    
    </div>
  );
}

export default CabeceraHistorialOrden;
